import React, { PropsWithChildren } from 'react';
import { IInvoice } from '../interfaces/IInvoice';
import { Grid, Typography } from '@material-ui/core';
import moment from 'moment';

interface InvoiceHistoryProps {
  invoices: IInvoice[] | undefined;
}
const InvoiceHistory = (props: PropsWithChildren<InvoiceHistoryProps>) => {
  const { invoices } = props;
  if (!invoices) {
    return <span>Loading invoices</span>;
  }
  return (
    <Grid container>
      {invoices.length === 0 && (
        <Grid item xs={12}>
          <Typography variant={'body1'}>No invoices.</Typography>
        </Grid>
      )}
      {invoices?.map((invoice: IInvoice, index: number) => {
        return (
          <Grid item xs={12} key={index}>
            <Grid container spacing={2} alignItems={'center'}>
              <Grid item>
                <Typography variant={'body1'}>
                  {moment(invoice.date).format('MMMM Do, YYYY')}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant={'body1'}>${invoice.amount}</Typography>
              </Grid>
              <Grid item>
                <Typography variant={'body1'}>{invoice.type}</Typography>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
export default InvoiceHistory;
